<template>
    <div class="column">
        <div class="notification is-warning is-fullwidth" v-if="getStatus">
            <button class="delete" @click="closeNotification"></button>
            Here we will show you the very important information. You can close it for now.
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                status: true,
            }
        },
        methods: {
          closeNotification (){
              this.status = false
          }
        },
        computed: {
            getStatus () {
                return this.status
            }
        }
    }
</script>

<style scoped>
    .box {
        min-height: 155px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Notifications.vue